import React, { useState } from 'react';
import { REPORT } from '../../../../permissions';
import { useUserDetails } from '../../../../services/auth/auth';
import { Notify } from '../../../../services/notification/notify';
import { useParams } from '../../../../services/routing/useRouteInfo';
import { ViewLayout } from '../../../shared/cardLayouts/viewLayout';
import { AutoSizeCard } from '../../../shared/cards/autoSizeCard';
import { StatCard } from '../../../shared/cards/statCard';
import { Button } from '../../../shared/inputs/button';
import { LoadText } from '../../../shared/load/loadText';
import { View } from '../../../shared/view/view';


import styles from './reportView.module.css';

/*

    This is a temporary report view that will just work for the IVR Audit Review.
    If more time is approved for more reporting in the future, this will all be redone.

*/
export const ReportView = () => {

    let { id } = useParams();
    const userDetails = useUserDetails();

    const [email, setEmail] = useState(userDetails?.username);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [orderIds, setOrderIds] = useState('');
    const [isCreating, setIsCreating] = useState(false);

    const orderIdArray = () => orderIds.split(',').map(id => id.trim());

    const handlePaste = e => {
        // Add commas between new lines and tabs to make pasting from an excel document easier
        let paste = (e.nativeEvent.clipboardData || window.clipboardData).getData('text');

        document.execCommand("insertText", false, paste.replace(/ ?\n|\t/g, ', '));

        e.preventDefault();
    };

    const validate = () => {
        const errors = [];
        
        if (!email) {
            errors.push('Email address is required.');
        }

        if (!orderIds || orderIdArray().length === 0) {
            errors.push('Order Ids are required.');
        }

        if (orderIdArray().length > 100) {
            errors.push('No more than 100 Order Ids are allowed.');
        }


        if (errors.length > 0) {
            Notify.error('Data is not valid', errors.map(e => <div>{e}</div>));
            return false;
        }

        return true;
    }

    const clearForm = () => {
        setEmail(userDetails?.username);
        setStartDate('');
        setEndDate('');
        setOrderIds('');
    }

    const create = async (url) => {
        if (!validate()) return;

        setIsCreating(true);

        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                end: endDate,
                orderIds: orderIdArray(),
                start: startDate,
            }),
        });

        if (res.status === 202 || res.status === 200) {
            Notify.success('Report Started', 'The report is being created. ' + getTimeEstimate());
        } else {
            Notify.error('Report Failed', 'There was an issue starting the report.');
        }

        setIsCreating(false);

        clearForm();
    }

    const getTimeEstimate = () => {
        const count = orderIdArray().length;

        if (count <= 5) return 'You can expect an email in about 1 minute.';
        if (count <= 25) return 'You can expect an email in about 5 minutes.';
        if (count <= 60) return 'You can expect an email in about 10 minutes.';
        if (count <= 100) return 'You can expect an email in about 15 minutes.';
        return 'Because of the number of records requested, this can longer than 15 minutes. It can take about 6 seconds per order id.'
    }

    return <View
        id={parseInt(id ?? '')}
        resourceName='Report'
        nameFunction={r => r?.name}
        restEndpoint='/communications/reports/'
        listUrl='/reports/'
        readPermissions={[REPORT.READ]}
        writePermissions={[REPORT.WRITE]}
        actions={[]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                <StatCard
                    title='Report Info'
                    stats={{
                            'Name': loading ? <LoadText /> : data.name ?? 'None',
                            'IVR': loading ? <LoadText /> : data.ivr ?? 'None',
                            'Description': loading ? <LoadText /> : data.description ?? 'None',
                        }}
                />
                <AutoSizeCard columns={2} className={styles.GenerateReport}>
                    <h1>Generate Report</h1>
                    <form className='formik'>
                        <label htmlFor='email'>Email</label>
                        <input type='email' value={email} onChange={e => setEmail(e.target.value)} />
                        <div className={styles.Split}>
                            <div>
                                <label htmlFor='start'>Start Date (Optional)</label>
                                <input type='datetime-local' name='start' value={startDate} onChange={e => setStartDate(e.target.value)} max={endDate} />
                            </div>
                            <div>
                                <label htmlFor='end'>End Date (Optional)</label>
                                <input type='datetime-local' name='end' value={endDate} onChange={e => setEndDate(e.target.value)} min={startDate} />
                            </div>
                        </div>

                        <label htmlFor='orderIds'>Order Ids</label>
                        <input type='text' name='orderIds' value={orderIds} onChange={e => setOrderIds(e.target.value)} onPaste={handlePaste} />

                        {orderIds && <>
                            <h2>Order Ids ({orderIdArray().length})</h2>
                            <div className={styles.Ids}>
                                {orderIdArray().map((id, i) => <React.Fragment key={i}>
                                    <code>{id}</code>
                                    {i <= orderIdArray().length - 3 && <>,&nbsp;&nbsp;</>}
                                    {i === orderIdArray().length - 2 && <>&nbsp;&nbsp;and&nbsp;&nbsp;</>}
                                </React.Fragment>)}
                            </div>
                        </>}


                        <Button type='button' disabled={isCreating} className={styles.ActionBtn + ' primary'} onClick={() => create(data.url)}>
                            Create
                        </Button>
                    </form>
                </AutoSizeCard>
            </ViewLayout>
        }
    </View>
}